import { Children, cloneElement, isValidElement } from 'react';
import confirmAction from '../../utilities/confirmAction';

/**
 * Drop-in replacement for antd Popconfirm that opens a centered confirm modal
 * instead of a popover anchored to the trigger.
 */
const CenteredPopconfirm = ({
  title,
  description,
  onConfirm,
  onCancel,
  okText,
  cancelText,
  okType,
  okButtonProps,
  cancelButtonProps,
  icon,
  disabled = false,
  children,
}) => {
  if (!isValidElement(children)) {
    return children ?? null;
  }

  const child = Children.only(children);

  const handleClick = (event) => {
    child.props.onClick?.(event);
    if (disabled || child.props.disabled || event?.defaultPrevented) return;

    // onOk must take no arguments: antd passes `close` to handlers that declare one and then skips auto-closing.
    confirmAction({
      title,
      description,
      okText,
      cancelText,
      okType,
      okButtonProps,
      cancelButtonProps,
      ...(icon !== undefined ? { icon } : {}),
      onOk: () => onConfirm?.(),
      onCancel: () => onCancel?.(),
    });
  };

  return cloneElement(child, { onClick: handleClick });
};

export default CenteredPopconfirm;
